<style lang="stylus">
    .upgrade-container
        display flex
        align-items center
        justify-content center
        width 100vw
        height 100vh
        iframe
            border none
            width 100%
            height 100%
            z-index 23333
        a
            color white
            text-decoration none
</style>

<template>
    <div class="upgrade-container" v-if="upgradeType">
        <!-- <Modal
            v-model="show"
            :title="$t('upgrade')"
            cancel-text
            class-name="upgrade-container"
            :styles="{top:'auto'}"
        >
            <div class="uc-warntext" v-html="warnText"></div>
            <div slot="footer">
                <Button type="primary" @click="learnMore()">{{$t("learnMore")}}</Button>
            </div>
        </Modal> -->
        <iframe id="upgframe" :src="callURL()"></iframe>
    </div>
</template>

<script>
    import appConfig from "@/public/globalConfig";
    export default {
        name: "upgrade",
        components: {},
        props: ["isAd"],
        data() {
            return {};
        },
        computed: {
            upgradeType() {
                return this.$store.state.publicStore.showUpgrade;
            },
            warnText() {
                return this.$t(`limit.${this.upgradeType}`);
            },
            userInfo() {
                return this.$store.state.userInfo || this.$store.state.user.userInfo;
            },
            seo_source() {
                if (this.$store.state.user?.seo_source) {
                    return `&seo_source=${this.$store.state.user?.seo_source}`;
                } else if (this.utm_term) {
                    return `&seo_source=4-${this.utm_term}`;
                } else {
                    return "";
                }
            },
        },
        methods: {
            callURL() {
                let lang = this.lang;
                let from = this.isAd ? "&from=ad" : "";
                let type = 0;
                switch (this.upgradeType) {
                    case "print":
                        type = 0;
                        break;
                    case "output":
                        type = 2;
                        break;
                    case "mfree": // 会员模板
                    case "cmfree":
                        type = 1;
                        break;
                    case "dropbox":
                        type = 5;
                        break;
                    case "googledrive":
                        type = 5;
                        break;
                    case "download":
                        type = 0;
                        break;
                    case "history":
                        type = 9;
                        break;
                    case "fileNum":
                        type = 3;
                        break;
                    case "newLib": // 新建符号库
                        type = 0;
                        break;
                    case "openLib": // 打开本地库
                        type = 0;
                        break;
                    case "addImgToLib": // 导入图片生成库
                        type = 0;
                        break;
                    case "limitShape": // 形状限制
                        type = 4;
                        break;
                    case "team": // 群组
                        type = 0;
                        break;
                    case "addPage":
                        type = 6;
                        break;
                    case "addRecycle":
                        type = 7;
                        break;
                    case "personalTemplateNumber":
                        type = 8;
                        break;
                    case "cloudSpace": // 非会员云空间满
                        type = 10;
                        break;
                    case "cloudSpaceVIP": // 会员云空间满
                        type = 11;
                        break;
                    case "playSlide": // 播放幻灯片
                        type = 13;
                        break;
                    case "pageBackgroundColor":
                        type = 14;
                        break;
                    case "limitShapeType":
                        type = 15;
                        break;
                    case "limitShapeSave":
                        type = 16;
                        break;
                    case "limitShapeExport":
                        type = 17;
                        break;
                    case "themesColor":
                        type = 18;
                        break;
                    case "themes":
                        type = 19;
                        break;
                    case "autoFormat":
                        type = 20;
                        break;
                    default:
                        type = 0;
                        break;
                }
                let trackMap = new Map([
                    ["limitShape", "symbolsLimit"],
                    ["fileNum", "cloudFileNumberLimit"],
                    ["fileSpace", "cloudFileSpaceLimit"],
                    ["mfree", "useVIPTemplate"],
                    ["cmfree", "useCummunityVipTemplate"],
                    ["addPage", "pageLimit"],
                    // ['newLib', 'customLibraryOver3'],
                    ["encrypt", "encryptFile"],
                    ["watermark", "removeExportwatermark"],
                    // ['clickUpgrade', 'clickUpgradeEntry'],
                    ["personalTemplateNumber", "personalTemplateNumberLimit"],
                    ["print", "printLimit"],
                    ["addRecycle", "recycleNumberLimit"],
                    ["history", "histoicalVersionLimit"],
                    ["cloudSpace", "cloudFileSpaceLimit"],
                    ["cloudSpaceVIP", "cloudFileSpaceLimit"],
                    ["pageBackgroundColor", "setBackground"],
                    ["playSlide", "presentation"],
                    ["limitShapeType", "library"],
                    ["limitShapeSave", "addSymbolToMyLibraryNew"],
                    ["limitShapeExport", "exportSymbol"],
                    ["themesColor", "themeColor"],
                    ["themes", "theme"],
                    ["autoFormat", "oneClickBeautify"],
                ]);
                this.$track("Upgrade popup", "pop up", `Scenes: ${["othersLimit", "templates", "export", "cloudfile", "shape", "dropbox"][type]}`);
                this.$gaTrack(
                    "path_popUpgardePlanTip",
                    `upgradeTrigger: ${["othersLimit", "templates", "export", "cloudfile", "shape", "dropbox"][type]}   `
                );
                const trigger = trackMap.get(this.upgradeType) || "others";
                this.sensors.track("popUpgradePlanTip", {
                    Catalogues: "payPath",
                    upgrade_trigger: trigger,
                });
                let userInfo = this.userInfo ? `&id=${this.userInfo.user_id}&token=${this.userInfo.token}` : "";
                return `${appConfig.sourcePath}maxupgrade/maxupgrade.html?appVersion=${this.appVersion}&pid=${this.appPid}&lang=${lang}&type=${type}${userInfo}&buildLang=${appConfig.language}${from}&upgrade_trigger=${trigger}&appEnv=${this.appEnv}${this.seo_source}`;
            },
        },
    };
</script>
